import { render, staticRenderFns } from "./ResponseDescText.vue?vue&type=template&id=65aaa223&scoped=true"
import script from "./ResponseDescText.vue?vue&type=script&lang=js"
export * from "./ResponseDescText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aaa223",
  null
  
)

export default component.exports